import { combineReducers } from 'redux';
import { modalDataReducer, tabDataReducer } from './miscPageDataReducers';
import pageDataReducer, { IPageDataReducer, IPageTree } from './pageDataReducer';
import browsePageMetadataReducer from './browsePageMetadataReducer';
import productPageMetadataReducer from './productPageMetadataReducer';
import lookDetailsPageMetadataReducer from './lookDetailsPageMetadataReducer';
import multiWidgetpageAnalyticsReducer from './multiWidgetpageAnalyticsReducer';
export { IPageDataReducer, IPageTree };
export default combineReducers({
    page: pageDataReducer,
    modal: modalDataReducer,
    tabs: tabDataReducer,
    browseMetadata: browsePageMetadataReducer,
    productPageMetadata: productPageMetadataReducer,
    lookDetailsPageMetadata: lookDetailsPageMetadataReducer,
    analtyticsData: multiWidgetpageAnalyticsReducer
});
